// src/app/components/login/login.component.ts

import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { loginRequest } from '../../../core/auth/auth-config';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  constructor(private authService: MsalService) { }
  ngOnInit(): void {
      this.authService.loginRedirect(loginRequest);
  }

  login() {
    // this.authService.loginRedirect(loginRequest);
  }
}
